import { AsyncPipe, CurrencyPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LombardFacade } from '@zero/lombard/domain';
import { UserMessagesComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent, ModalComponent } from '@zero/shared/ui-web-design-system';
import { UserMessagesHolderService } from '@zero/shared/util-web-app-services';
import { environment } from 'environments/environment';
import { LombardConditionsComponent } from '../lombard-conditions/lombard-conditions.component';
import { LombardExplanationComponent } from '../lombard-explanation/lombard-explanation.component';

@Component({
  selector: 'lombard-initial',
  templateUrl: './lombard-initial.component.html',
  styleUrls: ['./lombard-initial.component.scss'],
  imports: [
    TranslocoPipe,
    LombardConditionsComponent,
    LombardExplanationComponent,
    UserMessagesComponent,
    ButtonComponent,
    AsyncPipe,
    CurrencyPipe,
    ModalComponent,
  ],
})
export class LombardInitialComponent {
  public readonly facade = inject(LombardFacade);
  public readonly modal = inject(NgbModal);
  readonly #sanitizer = inject(DomSanitizer);
  readonly #msgService = inject(UserMessagesHolderService);

  public readonly lombardIntermediationAgreementLink: SafeUrl = this.#sanitizer.bypassSecurityTrustUrl(
    `${environment.apihost}/api/lombard/intermediationagreementpdf/Depotkredit_Vermittlungsvereinbarung.pdf`,
  );

  public currentCredit = 0;
  public isDropdownOpen = false;

  public toggleDropdown = (currentCredit: number): void => {
    this.currentCredit = currentCredit;
    this.isDropdownOpen = !this.isDropdownOpen;
  };

  public handleDropdownChange = (_: Event, creditLine: string): void => {
    this.currentCredit = Number(creditLine);
  };

  public applyForCredit = (suggestedCredit: number): void => {
    this.#msgService.clearAllMessages();
    if (!this.currentCredit && !suggestedCredit) {
      return;
    }

    this.facade.applyForCredit(this.currentCredit || suggestedCredit);
  };
}
